import React, { useState } from 'react';
import { Button, Card, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import FormErrorHandler
  from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/FormErrorHandler';
import AltErrorWrapper
  from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/AltErrorWrapper/AltErrorWrapper';
import { useDispatch, useSelector } from 'react-redux';
import FormAlertBox
  from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/FormAlertBox/FormAlertBox';
import { connectModalContainerContextToComponent } from '../../contexts/ModalContext/ModalContext';
import {
  editSavedSearch,
  selectSavedSearchById,
} from '../../redux/slices/savedSearchesSlice/savedSearchesSlice';
import FilterDisplay from './FilterDisplay';
import AdvancedSearchUtility from '../../utility/AdvancedSearchUtility';
import SearchType from '../../utility/types/SearchType';

function EditSavedSearchModal(props) {
  const {
    setModalJSX,
    savedSearchId,
    handleViewInListClick,
    searchType,
  } = props;
  const selectedSearch = useSelector((state) => selectSavedSearchById(state, savedSearchId));
  const [show, setShow] = useState(true);
  const [newDescription, setNewDescription] = useState(selectedSearch.description);
  const [newName, setNewName] = useState(selectedSearch.name);
  const dispatch = useDispatch();
  const [errors, setErrors] = useState([]);

  const sortedFilters = AdvancedSearchUtility
    .sortFiltersByFacetType(selectedSearch.filters);

  const closeModalHandler = () => {
    setShow(false);
    setModalJSX((<></>));
  };
  const entityName = searchType === SearchType.ALERT ? 'Alerts' : 'Devices';
  return (
    <Modal
      show={show}
      onHide={closeModalHandler}
      fullscreen="md-down"
      size="lg"
    >
      <Modal.Header
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        closeButton
      >
        <Modal.Title>
          Edit Saved Search
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormErrorHandler
          errorList={errors}
          fieldList={[
            'name',
            'description',
          ]}
        >
          <FormAlertBox />
          <form>
            <div className="container">
              <div className="form-group">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="description">Name</label>
                <AltErrorWrapper fieldId="name">
                  <input
                    id="description"
                    type="text"
                    placeholder="Name"
                    value={newName}
                    onChange={(e) => setNewName(
                      e.target.value,
                    )}
                    className="form-control"
                  />
                </AltErrorWrapper>
              </div>

              <div className="form-group">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="description">Description</label>
                <AltErrorWrapper fieldId="description">
                  <input
                    id="description"
                    type="text"
                    placeholder="Description"
                    value={newDescription}
                    onChange={(e) => setNewDescription(
                      e.target.value,
                    )}
                    className="form-control"
                  />
                </AltErrorWrapper>
              </div>

              <div className="row">
                <div className="col">
                  <Card style={{ backgroundColor: '#dddddd' }}>
                    <Card.Body>
                      <div style={{
                        overflowY: 'auto',
                        maxHeight: '250px',
                      }}
                      >
                        <Card.Text>
                          <ol>
                            {Object.entries(sortedFilters)
                              .map(([k, v]) => (
                                <li className="mb-2">
                                  <FilterDisplay facetId={parseInt(k, 10)} filters={v} />
                                </li>
                              ))}
                          </ol>
                        </Card.Text>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="row">
                <div className="col m-1">
                  <i>
                    To make changes to filters, load this Search in your
                    {' '}
                    {entityName}
                    {' '}
                    List. From there,
                    click
                    on any filter in the Search bar to make changes.
                  </i>
                </div>
              </div>
            </div>
          </form>
        </FormErrorHandler>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={handleViewInListClick}
          className="text-nowrap"
        >
          View in
          {' '}
          {entityName}
          {' '}
          List
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            dispatch(editSavedSearch({
              savedSearch:
                {
                  id: selectedSearch.id,
                  name: newName,
                  description: newDescription,
                  filters: [...selectedSearch.filters],
                },
              patchFields: ['name', 'description'],
            })).unwrap().then(() => closeModalHandler())
              .catch((e) => setErrors(e.data));
          }}
          className="text-nowrap"
        >
          Save Changes
        </Button>

      </Modal.Footer>
    </Modal>
  );
}

EditSavedSearchModal.propTypes = {
  setModalJSX: PropTypes.func.isRequired,
  savedSearchId: PropTypes.number.isRequired,
  handleViewInListClick: PropTypes.func.isRequired,
  searchType: PropTypes.oneOf([0, 1, 2]).isRequired,
};

export default connectModalContainerContextToComponent(EditSavedSearchModal);
